import { createGlobalStyle } from 'styled-components'
import { TodistusTheme } from 'todistukset-ui/src/vtj/todistus-theme'

/* We need the type specification {theme: TodistusTheme}, because
 * external-module-types declares the DefaultTheme from styled-components
 * as our TodistusTheme, but imports from neighbor projects won't see
 * that declaration */
export const GlobalStyle = createGlobalStyle<{ theme?: TodistusTheme }>`
  /* Overrides to GlobalStyle from common-ui-components */
  a {
    color: ${({ theme }) => theme.colors.highlightBase};
  }

  a:visited {
    color: ${({ theme }) => theme.colors.accentTertiaryDark1};
  }

  input {
    width: initial;
  }

  ol li, ul li {
    line-height: 1.333; /* 24px/18px */
  }

  /**
   * The Expander component breaks in Chrome version 129. The content of the expander overflows outside the box.
   * This is a temporary fix until the suomifi-library is fixed. The faulty library version is 14.0.0.
   * TODO: remove this after the problem is solved
   */
  .fi-expander_content {
    animation: none !important;
  }
`
